import React, { useState, useEffect } from 'react';
import CancelarReciboForm from './CancelarReciboForm'
import { useForm } from '../../hooks/useForm';
import { Grid } from '@material-ui/core';

import CancelarReciboSearch from './CancelarReciboSearch';

import { InputAdornment, makeStyles, ButtonGroup, Button as MuiButton } from '@material-ui/core';

const generateOrderNumber = () => Math.floor(100000 + Math.random() * 900000).toString();

const getFreshModelObject = () => ({
    ordernumber: generateOrderNumber(),
    ordermasterid: '',
    reciboseleccionado: 0,
    codigocancelacion: '',
    usuarioautoriza: '',
    claveautoriza: '',
    customerId: 0

})

const useStyles = makeStyles(theme => ({
    
    labelAlumnoCarrito: {
        backgroundColor: '#f2f2f2',
        color: '#0000ff',
        margin: theme.spacing(1),
        fontSize: 'small'
    }
}))


export default function CancelarRecibo(props) {

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetFormControls
    } = useForm(getFreshModelObject);

    const [alumnoid, setAlumnoid] = useState(0);
    const [nombrealumno, setNombrealumno] = useState(0);
    const [gradoalumno, setGradoalumno] = useState('');
    const [nivelalumno, setNivelalumno] = useState(0);
    const [grupoalumno, setGrupoalumno] = useState('');
    const [correo2, setCorreo2] = useState('');

    const classes = useStyles();

    useEffect(() => {
        //setCorreo(props.correo2);
        setAlumnoid(parseInt(props.alumnoid));

        //console.log("---------id--*****>" + props.alumnoid);
        //console.log("---------Correo2--*****>" + props.correo2);
        //console.log("---------***>" + JSON.stringify(props));

    }, [props.alumnoid]);

    useEffect(() => {
        setNombrealumno(props.nombrealumno);
    }, [props.nombrealumno]);

    useEffect(() => {
        setGradoalumno(props.gradoalumno);
    }, [props.gradoalumno]);

    useEffect(() => {
        setNivelalumno(props.nivelalumno);
    }, [props.nivelalumno]);

    useEffect(() => {
        setGrupoalumno(props.grupoalumno);
    }, [props.grupoalumno]);


    useEffect(() => {
        //setCorreo(props.correo2);
        setCorreo2(props.correo2);
        //console.log("---------***>" + JSON.stringify(props));
    }, [props.correo2]);



    return (
        <Grid container spacing={2} className={classes.labelAlumnoCarrito}>
            <Grid item xs={6} >
                <CancelarReciboForm
                    {...{
                        correo2,
                        alumnoid,
                        nombrealumno,
                        gradoalumno,
                        nivelalumno,
                        grupoalumno,
                        values,
                        setValues,
                        errors,
                        setErrors,
                        handleInputChange,
                        resetFormControls
                    }}
                />
            </Grid>


            <Grid item xs={6}>
                <CancelarReciboSearch
                    {...{
                        alumnoid,
                        values,
                        setValues
                    }}
                />
            </Grid>

        </Grid>
    )
}
